import { useEffect, useRef, useState } from 'react';
// @mui
import Alert from '@mui/material/Alert';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
//
import { SplashScreen } from 'src/components/loading-screen';
import { RouterLink } from 'src/routes/components';
import { useRouter } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';
import { PATH_AFTER_LOGIN } from 'src/config-global';
import { useAuthContext } from 'src/auth/hooks';

// ----------------------------------------------------------------------

export default function OAuthCallbackPage() {
  const router = useRouter();
  const { loginFromToken } = useAuthContext();
  const [failed, setFailed] = useState(false);
  const startedRef = useRef(false);

  useEffect(() => {
    if (startedRef.current) {
      return;
    }
    startedRef.current = true;

    const hashParams = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    const token = hashParams.get('token');

    // Scrub the token from the URL before anything else can log it.
    window.history.replaceState(null, '', window.location.pathname);

    if (!token) {
      setFailed(true);
      return;
    }

    loginFromToken(token)
      .then(() => router.replace(PATH_AFTER_LOGIN))
      .catch(() => setFailed(true));
  }, [loginFromToken, router]);

  if (failed) {
    return (
      <Stack alignItems="center" justifyContent="center" sx={{ minHeight: '100vh', px: 3 }} spacing={2}>
        <Alert severity="error">We couldn&apos;t complete your Google sign-in.</Alert>
        <Link component={RouterLink} href={paths.auth.login} variant="subtitle2">
          Back to sign in
        </Link>
      </Stack>
    );
  }

  return <SplashScreen />;
}
